module.exports = __webpack_public_path__ + "static/media/3.7f170a6a.jpg";